import React from "react";
import { Loader, MultiSelect } from "@mantine/core";
import useTagsListApiService from "../services/api/TagsListApiService";
import { HttpClientError } from "../../../providers/HttpClient";

type TagMultiSelectProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  onDropdownClose?: () => void;
};

const TagMultiSelect: React.FC<TagMultiSelectProps> = ({
  form,
  onDropdownClose,
}) => {
  const {
    isLoading: isTagLoading,
    isError,
    error,
    data: tagData,
  } = useTagsListApiService({});

  const id = "tags";
  const title = "Select tags";
  const description = "Filter tags to target specfic employee groups";

  if (isError) {
    return (
      <MultiSelect
        id={id}
        name={id}
        data={[]}
        label={title}
        disabled
        error={HttpClientError(error)}
      />
    );
  }

  if (!tagData) {
    return (
      <MultiSelect
        id={id}
        name={id}
        data={[]}
        label={title}
        placeholder="No tags available"
        disabled
      />
    );
  }

  return (
    <MultiSelect
      data={tagData.map((it) => ({
        value: it.id.toString(),
        label: it.name,
        group: it.category,
      }))}
      label={title}
      description={description}
      placeholder="Select or search for tags..."
      rightSection={isTagLoading ? <Loader size={16} /> : null}
      searchable
      filter={(value, selected, item) => {
        if (selected) {
          return false;
        }
        if (item.label?.toLowerCase().includes(value.toLowerCase())) {
          return true;
        }
        if (item.group?.toLowerCase().includes(value.toLowerCase())) {
          return true;
        }
        return false;
      }}
      clearable
      required
      onDropdownClose={onDropdownClose}
      {...form.getInputProps(id, { type: "multiselect" })}
    />
  );
};

export default TagMultiSelect;
